'use strict';

import Highcharts from "highcharts/highstock.src";
import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.config(function () {
  if (!Highcharts.translations) {
    Highcharts.translations = [];
  }
  Highcharts.translations["fr_FR"] = {
    months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
    weekdays: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
    shortMonths: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Aout', 'Sept', 'Oct', 'Nov', 'Déc'],
    decimalPoint: ",",
    thousandsSep: " ",
    numericSymbols: ["k", "M", "G", "T", "P", "E"],
    downloadPNG: "Télécharger en image PNG",
    downloadJPEG: "Télécharger en image JPEG",
    downloadPDF: "Télécharger en document PDF",
    downloadSVG: "Télécharger en document Vectoriel",
    exportButtonTitle: "Export du graphique",
    loading: "Chargement en cours...",
    printButtonTitle: "Imprimer le graphique",
    resetZoom: "Réinitialiser le zoom",
    resetZoomTitle: "Réinitialiser le zoom au niveau 1:1",
    contextButtonTitle: "Actions",
    ExporterLeGraphique: "Exporter le graphique",
    AfficherEnPleinEcran: "Afficher en plein écran"
  };
  Highcharts.translations["en_GB"] = {
    loading: "Loading...",
    months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    weekdays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    decimalPoint: ".",
    thousandsSep: ",",
    numericSymbols: ["k", "M", "G", "T", "P", "E"],
    resetZoom: "Reset zoom",
    resetZoomTitle: "Reset zoom level 1:1",
    rangeSelectorZoom: "Zoom",
    rangeSelectorFrom: "From:",
    rangeSelectorTo: "To:",
    downloadPNG: "Download PNG image",
    downloadJPEG: "Download JPEG image",
    downloadPDF: "Download PDF document",
    downloadSVG: "Download SVG vector image",
    exportButtonTitle: "Export to raster or vector image",
    printButtonTitle: "Print the chart",
    contextButtonTitle: "Actions",
    ExporterLeGraphique: "Export chart",
    AfficherEnPleinEcran: "Show in full screen"
  };
});
ngModule.run(function () {
  Highcharts.setOptions({
    lang: Highcharts.translations["fr_FR"]
  });
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/highcharts/highcharts-i18n.js
// module id = 2964
// module chunks = 13